const socials = {
    email: "contact.swanhtetaung@gmail.com",
    github: "https://github.com/SwanHtetAungX",
    githubUsername: "SwanHtetAungX",
    linkedin: "https://www.linkedin.com/in/swan-htet-aungx",
    linkedinUsername: "swan-htet-aungx"
};

export default socials;